//docs list
import VaultInfoCard from "./vault-infocard";

export default function TeamDocsModule(props) {

  const data = props.data;

  if (data && data.length===0)
  return (<><p className="text-muted small">No Records</p> </>)

  return (
    <>
    <div className="">

      {data && data.map((item, i) => (
          
        <div className="col" key={i}>
          <VaultInfoCard data={item} />
        </div>

      ))}
    </div>
    </>
  )
}